<template>
  <UiDivider class="mt-8" />
  <div class="flex flex-row justify-between">
    <UiButton
      id="product-list-pagination-previous"
      :icon="IconChevron"
      icon-side="left"
      variant="tertiary"
      class="!rounded-none !border-none !shadow-none"
      icon-class="rotate-90"
      :disabled="currentPage === 1"
      @click="setCurrentPage(currentPage - 1)"
    >
      {{ isMobile ? '' : $t('general.previous') }}
    </UiButton>
    <div class="flex flex-row">
      <UiText v-if="pageCount > 3 && currentPage > 2" class="self-end px-4 py-2 text-neutral-700">
        {{ $t('general.symbols.threeDots') }}
      </UiText>
      <template v-for="page in visiblePages" :key="page">
        <UiButton
          :id="`product-list-pagination-${page}`"
          variant="tertiary"
          type="neutral"
          class="!rounded-none border-x-0 border-b-0 border-t-4 !shadow-none"
          :class="currentPage === page ? '!border-primary-700 !text-primary-700' : '!border-transparent'"
          :disabled="pageCount === 1"
          @click="setCurrentPage(page)"
        >
          {{ page }}
        </UiButton>
      </template>
      <UiText v-if="pageCount > 3 && currentPage <= pageCount - 2" class="self-end px-4 py-2 text-neutral-700">
        {{ $t('general.symbols.threeDots') }}
      </UiText>
    </div>
    <UiButton
      id="product-list-pagination-next"
      :icon="IconChevron"
      icon-side="right"
      variant="tertiary"
      class="!rounded-none !border-none !shadow-none"
      icon-class="-rotate-90"
      :disabled="currentPage === pageCount"
      @click="setCurrentPage(currentPage + 1)"
    >
      {{ isMobile ? '' : $t('general.next') }}
    </UiButton>
  </div>
</template>

<script setup lang="ts">
import { IconChevron } from '#components';

import type { ProductListPaginationProps } from '~/components/ProductList/types';

const { isMobile } = useBreakpoints();

const props = defineProps<ProductListPaginationProps>();

const pageCount = computed(() => (props.pagination ? Math.ceil(props.pagination.total / props.pagination.limit) : 1));

const visiblePages = computed(() => {
  const total = pageCount.value;

  if (total <= 3) {
    return Array.from({ length: total }, (_, i) => i + 1);
  } else {
    if (props.currentPage <= 2) {
      return [1, 2, 3];
    } else if (props.currentPage >= total - 1) {
      return [total - 2, total - 1, total];
    } else {
      return [props.currentPage - 1, props.currentPage, props.currentPage + 1];
    }
  }
});
</script>
